module.exports = __webpack_public_path__ + "img/3_3.926f5b57.png";